import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../components/auth/AuthProvider";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function usePayment() {
  const {
    loading,
    setLoading,
    authenticated,
    // user,
    status,
    setStatus,
    paymentLocation,
    setPaymetLocation,
    payload,
    setPayload,
    setSessionId,
    sessionId,
    payed,
    prevLocation,
    storage,
    // googleUser,
    apiUrl,
    setError,
    setPrevLocation,
    setPayedStressFatigue,
    payedStressFatigue,
  } = useContext(AuthContext);

  const [servicePayment, setServicePayment] = useState(null);
  const [urlExists, setUrlExists] = useState(false);

  const navigate = useNavigate();

  async function handlePayment(user, googleUser, slug, title) {
    if (!user && !googleUser) {
      navigate("/login");
      return;
    }

    setLoading(true);

    if (user) {
      try {
        // console.log(e.target.value);

        const res = await fetch(apiUrl + "/product/v1/checkout", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount: 499, // €14.90 in cents
            quantity: 1,
            name: title,
            currency: "EUR",
            slug: slug && slug,
            username: user && user.username,
            redirect:
              localStorage.getItem("postLoginRedirectTheme") ||
              prevLocation.includes("/Phase 1/")
                ? "phase1"
                : // redirect:
                  "success",
          }),
        });

        if (!res.ok) {
          const errorText = await res.text();
          console.error("Checkout failed:", errorText);
          setLoading(false);
          return;
        }

        const data = await res.json();

        setStatus(data?.status);
        setSessionId(data?.sessionId);

        if (data && data.sessionUrl) {
          setServicePayment(data);
          setLoading(true);

          if (user) {
            window.location.href = data.sessionUrl;
            setPaymetLocation(data.sessionUrl);
          }
        } else {
          setLoading(false);
          setUrlExists(false);
        }
      } catch (e) {
        console.error("Payment error:", e);
      }
    }

    if (googleUser) {
      try {
        const res = await fetch(apiUrl + "/product/v1/checkout", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount: 499, // €14.90 in cents
            quantity: 1,
            name: title,
            currency: "EUR",
            slug: slug && slug,
            googleEmail: googleUser && googleUser.email,
            redirect:
              localStorage.getItem("postLoginRedirectTheme") ||
              prevLocation.includes("/Phase 1/")
                ? "phase1"
                : // redirect:
                  "success",
          }),
        });

        const data = await res.json();

        setStatus(data?.status);
        setSessionId(data?.sessionId);
        if (data && data.sessionUrl) {
          setServicePayment(data);
          setLoading(true);

          if (googleUser) {
            window.location.href = data.sessionUrl;
            setPaymetLocation(data.sessionUrl);
          } else {
            window.location.href = "http://localhost:3000/login";
          }
        } else {
          setLoading(false);
          setUrlExists(false);
        }
      } catch (e) {
        console.error("Payment error:", e);
      }
    }
  }

  return { handlePayment };
}
